import React from 'react';
import { NewLabel } from '@ui-library/typography';
import { SingleSelectDropdown } from '@ui-library/select';
import { Select } from 'antd';
import TimePicker from '@ui-library/pickers/timePicker';
import { CaretDownFilled } from '@ant-design/icons';
import { ScheduleI } from '.';
import { ScheduleTypes } from '../scheduleTypes';

const { Option } = Select;

interface BasicScheduleProps {
  value?: Partial<IBasicSchedule>;
  onChange: (value: Partial<IBasicSchedule>) => void;
}

export interface IBasicSchedule {
  every: number;
  unit: 'minutes';
  start_at?: string;
  end_at?: string;
}

const options = [
  {
    name: 'Every 24 hours',
    value: 1440,
  },
  {
    name: 'Every 12 hours',
    value: 720,
  },
  {
    name: 'Every 6 hours',
    value: 360,
  },
  {
    name: 'Every 3 hours',
    value: 180,
  },
  {
    name: 'Every 1 hour',
    value: 60,
  },

  {
    name: 'Every 30 minutes',
    value: 30,
  },
];
const BasicSchedule = (props: BasicScheduleProps) => {
  const { value, onChange } = props;
  const defaultVal: ScheduleI = value?.every
    ? value
    : { every: Number(options[0].value), unit: 'minutes', type: ScheduleTypes.Basic };
  const [schedule, setSchedule] = React.useState<ScheduleI>(defaultVal);
  const onChangeFrequencyCL = React.useCallback(
    (v: number) => {
      const selectedSchedule: ScheduleI = {
        every: v,
        unit: 'minutes',
        type: ScheduleTypes.Basic,
      };
      if (!v) {
        selectedSchedule.end_at = undefined;
        selectedSchedule.start_at = undefined;
      }
      setSchedule({ ...schedule, ...selectedSchedule });
    },
    [onChange],
  );
  const onChangeStartAtCL = React.useCallback(
    (_, v: string) => {
      const nextState = { ...schedule };
      if (v) {
        nextState.start_at = v;
      } else {
        delete nextState.start_at;
      }
      setSchedule(nextState);
    },
    [onChange],
  );
  React.useEffect(() => {
    onChange(schedule);
  }, [schedule]);
  const freqVal = schedule.every;
  const dateVal = (schedule.start_at && String(schedule.start_at)) || undefined;
  return (
    <>
      <NewLabel className="m-b-xs">Frequency</NewLabel>
      <SingleSelectDropdown
        value={freqVal}
        onChange={onChangeFrequencyCL}
        data-testid="sync-frequency"
        suffixIcon={<CaretDownFilled />}
      >
        {options.map((opt) => (
          <Option value={opt.value} key={`single-select-opt-key-${opt.value}`}>
            {opt.name}
          </Option>
        ))}
      </SingleSelectDropdown>
      <TimePicker
        disabled={!schedule.every}
        field={{
          default: schedule.every ? dateVal : null,
          label: 'Sync Starting At (Optional, UTC)',
        }}
        options={{ omitSeconds: true, minuteStep: 15 }}
        onChange={onChangeStartAtCL}
      />
    </>
  );
};

export default BasicSchedule;
